//import { bus, axios, apiURL } from '../main'

/*  i'll be mixed in in Analysen.vue */
import moment from "moment";
export default {
  computed: {
    analysenFilter() {
      //his.$store.state.analysenStore.labor
      return {
        von: moment(this.$store.state.searchStore.searchValues.von).toDate(),
        bis: this.$store.state.searchStore.searchValues.bis,
        AnatypID: this.$store.state.analysenStore.anatypSelected,
        tierartID: this.$store.state.searchStore.searchValues.tierartSelected,
        btrid: this.$store.state.searchStore.searchValues.betriebSelected,
      }
    }
  },
  watch: {
    'analysenFilter.von'() {
      this.$store.dispatch("loadAnalysen", this.analysenFilter);
    },
    'analysenFilter.bis'() {
      this.$store.dispatch("loadAnalysen", this.analysenFilter);
    }
  }
}